import { FC } from 'react';
import { ProductCard } from '@/src/app/[locale]/stores/[store]/[storeId]/product/components/ProductCard';
import { ICmsSection } from '../services/types';
import { BasicProductDataResponse } from '@/src/types/catalog';
import Typography from '@/src/components/ui/typography';
import Container from '@/src/components/ui/container';
import { ThemeLayout } from './ThemeLayout';
import { Link } from '@/src/i18n/navigation';
import { SliderLayout } from '@/src/components/Layout/SliderLayout';

type Props = {
  data: ICmsSection;
  globalLiveTimes?: Record<number, string>;
};

export const PromotedProducts: FC<Props> = ({ data, globalLiveTimes }) => {
  const slides = (
    Array.isArray(data.content)
      ? data.content
      : (data.content?.products ?? data.content?.Products ?? [])
  ) as BasicProductDataResponse[];

  return (
    <Container>
      <ThemeLayout
        id={data?.id.toString()}
        theme={data.theme}
        alt={data.name}
        header={
          <div className="flex w-full items-center justify-between gap-2">
            <Typography
              variant="h4"
              component={'h2'}
              weight={'semibold'}
              align={'start'}
              className="text-inherit"
            >
              {data.name}
            </Typography>
          </div>
        }
      >
        <SliderLayout
          opts={{ slidesToScroll: 'auto', dragFree: true }}
          conatinerClassName="lg:ps-6 ps-3 mb-2"
          itemsClassName="basis-[46%] shrink-0 sm:basis-[30%] md:basis-[24.5%] lg:basis-[21%] md:pl-4 pl-2"
        >
          {slides?.map((item) => {
            const storeId = Number(item.storeId || item.branchId);
            const storeTime = globalLiveTimes?.[storeId] || '';

            return (
              <ProductCard
                key={item.integrationId}
                productDetails={item}
                scroll={true}
                storeTime={storeTime}
              />
            );
          })}
        </SliderLayout>
      </ThemeLayout>
    </Container>
  );
};
